<h1 mat-dialog-title class="text-center">{{ dialogTitle | translate }}</h1>
<form class="example-form" id="form" [formGroup]="fertiliserForm">
    <div *ngIf="this.superuser && this.editData.isEdit && this.editData.row.status === 'pending'" class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.STATUS'| translate }}</label>

                <mat-form-field>
                    <mat-select formControlName="status" [(value)]="status">
                        <mat-option value="pending">{{ 'PRODUCT.PENDING'| translate }}</mat-option>
                        <mat-option value="approved">{{ 'PRODUCT.APPROVE'| translate }}</mat-option>
                        <mat-option value="declined">{{ 'PRODUCT.DECLINE'| translate }}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.COMMERCIAL'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="commercialName" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.CROP_TYPE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="cropType" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center" [hidden]="this.superuser && this.editData.isEdit && this.editData.row.status === 'pending'">
        <div class="row">
            <div class="col-6">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.COMMERCIAL'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="commercialName" />
                </mat-form-field>
            </div>
            <div class="col-6">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.CROP_TYPE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="cropType" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.TYPE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="type" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">{{ 'PRODUCT.SUBSTANCE'| translate }}</label>

                <mat-form-field>
                    <input matInput formControlName="substance" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">Efn</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="efn" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">Ef5</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="ef5" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">Efert</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="efert" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">Fvoln</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="fvoln" />
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="flex justify-center">
        <div class="row">
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">N</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="n" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">P</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="p" />
                </mat-form-field>
            </div>
            <div class="col-4">
                <label class="block uppercase text-gray-600 text-xs font-bold mb-3" htmlFor="equipmentName">K</label>

                <mat-form-field>
                    <input matInput type="number" min="0" formControlName="k" />
                </mat-form-field>
            </div>
        </div>
    </div>
</form>
<div id="buttons_group" class="mt-2 mx-1 p-3 float-right">
    <div class="row">
        <div class="col-5">
            <button mat-raised-button mat-dialog-close="Close"
                style="background-color: red; color: white;">{{ closeButton | translate }}</button>
        </div>
        <div class="col-5">
            <button mat-raised-button mat-dialog-close (click)="addFertiliser()"
                style="background-color: #3fb56d; color: white;">{{ actionButton | translate }}</button>
        </div>
    </div>
</div>